import _objectSpread from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = {
  class: "tui-contact-list-item-header-left"
};
var _hoisted_3 = {
  class: "tui-contact-list-item-header-right"
};
var _hoisted_4 = {
  key: 0,
  class: "tui-contact-list-item-header-right-unread"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  key: 1,
  class: "tui-contact-list"
};
var _hoisted_7 = {
  key: 0,
  class: "tui-contact-search-list"
};
var _hoisted_8 = {
  class: "tui-contact-search-list-title"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  key: 0,
  class: "tui-contact-search-list-default"
};
import { TUITranslateService, TUIStore, StoreName, TUIFriendService, TUIUserService } from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import { ref, computed, onMounted, onUnmounted, provide } from '../../../adapter-vue';
import Icon from '../../common/Icon.vue';
import downSVG from '../../../assets/icon/down-icon.svg';
import rightSVG from '../../../assets/icon/right-icon.svg';
import ContactListItem from './contact-list-item/index.vue';
import { isPC } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    var currentContactListKey = ref('');
    var currentContactInfo = ref({});
    var contactListMap = ref({
      // friendApplicationList: {
      //   key: 'friendApplicationList',
      //   title: '新的联系人',
      //   list: [] as FriendApplication[],
      //   unreadCount: 0
      // },
      // blackList: {
      //   key: 'blackList',
      //   title: '黑名单',
      //   list: [] as IBlackListUserItem[]
      // },
      groupList: {
        key: 'groupList',
        title: '我的群聊',
        list: []
      }
      // friendList: {
      //   key: 'friendList',
      //   title: '我的好友',
      //   list: [] as Friend[]
      // }
    });
    var contactSearchingStatus = ref(false);
    var contactSearchResult = ref();
    var displayOnlineStatus = ref(false);
    var userOnlineStatusMap = ref();
    var isContactSearchNoResult = computed(() => {
      var _contactSearchResult$, _contactSearchResult$2;
      return !(contactSearchResult !== null && contactSearchResult !== void 0 && (_contactSearchResult$ = contactSearchResult.value) !== null && _contactSearchResult$ !== void 0 && (_contactSearchResult$ = _contactSearchResult$.user) !== null && _contactSearchResult$ !== void 0 && _contactSearchResult$.list[0]) && !(contactSearchResult !== null && contactSearchResult !== void 0 && (_contactSearchResult$2 = contactSearchResult.value) !== null && _contactSearchResult$2 !== void 0 && (_contactSearchResult$2 = _contactSearchResult$2.group) !== null && _contactSearchResult$2 !== void 0 && _contactSearchResult$2.list[0]);
    });
    onMounted(() => {
      TUIStore.watch(StoreName.APP, {
        enabledCustomerServicePlugin: onCustomerServiceCommercialPluginUpdated
      });
      TUIStore.watch(StoreName.GRP, {
        groupList: onGroupListUpdated
      });
      TUIStore.watch(StoreName.USER, {
        // userBlacklist: onUserBlacklistUpdated,
        displayOnlineStatus: onDisplayOnlineStatusUpdated,
        userStatusList: onUserStatusListUpdated
      });
      TUIStore.watch(StoreName.FRIEND, {
        // friendList: onFriendListUpdated,
        // friendApplicationList: onFriendApplicationListUpdated,
        // friendApplicationUnreadCount: onFriendApplicationUnreadCountUpdated
      });
      TUIStore.watch(StoreName.CUSTOM, {
        currentContactSearchingStatus: onCurrentContactSearchingStatusUpdated,
        currentContactSearchResult: onCurrentContactSearchResultUpdated,
        currentContactListKey: onCurrentContactListKeyUpdated,
        currentContactInfo: onCurrentContactInfoUpdated
      });
      toggleCurrentContactList('groupList');
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.APP, {
        enabledCustomerServicePlugin: onCustomerServiceCommercialPluginUpdated
      });
      TUIStore.unwatch(StoreName.GRP, {
        groupList: onGroupListUpdated
      });
      TUIStore.unwatch(StoreName.USER, {
        // userBlacklist: onUserBlacklistUpdated,
        displayOnlineStatus: onDisplayOnlineStatusUpdated,
        userStatusList: onUserStatusListUpdated
      });
      TUIStore.unwatch(StoreName.FRIEND, {
        // friendList: onFriendListUpdated,
        // friendApplicationList: onFriendApplicationListUpdated,
        // friendApplicationUnreadCount: onFriendApplicationUnreadCountUpdated
      });
      TUIStore.unwatch(StoreName.CUSTOM, {
        currentContactSearchingStatus: onCurrentContactSearchingStatusUpdated,
        currentContactSearchResult: onCurrentContactSearchResultUpdated,
        currentContactListKey: onCurrentContactListKeyUpdated,
        currentContactInfo: onCurrentContactInfoUpdated
      });
    });
    function toggleCurrentContactList(key) {
      console.log('currentContactListKey.value->', currentContactListKey.value);
      console.log("key->", key);
      if (currentContactListKey.value === key) {
        currentContactListKey.value = '';
        currentContactInfo.value = {};
        TUIStore.update(StoreName.CUSTOM, 'currentContactListKey', '');
        TUIStore.update(StoreName.CUSTOM, 'currentContactInfo', {});
      } else {
        currentContactListKey.value = key;
        TUIStore.update(StoreName.CUSTOM, 'currentContactListKey', key);
        if (key === 'friendApplicationList') {
          TUIFriendService.setFriendApplicationRead();
        }
      }
    }
    function selectItem(item) {
      currentContactInfo.value = item;
      // 单独处理：
      // 对于 搜索列表 中 某结果，查看 contactInfo 详情前，需要对于“已在群组列表/已在好友列表” 的情况进行数据更新，已获得更详细的信息
      if (contactSearchingStatus.value) {
        var _currentContactInfo$v, _currentContactInfo$v3;
        var targetListItem;
        if ((_currentContactInfo$v = currentContactInfo.value) !== null && _currentContactInfo$v !== void 0 && _currentContactInfo$v.userID) {
          var _contactListMap$value;
          targetListItem = (_contactListMap$value = contactListMap.value) === null || _contactListMap$value === void 0 || (_contactListMap$value = _contactListMap$value.friendList) === null || _contactListMap$value === void 0 || (_contactListMap$value = _contactListMap$value.list) === null || _contactListMap$value === void 0 ? void 0 : _contactListMap$value.find(item => {
            var _currentContactInfo$v2;
            return (item === null || item === void 0 ? void 0 : item.userID) === ((_currentContactInfo$v2 = currentContactInfo.value) === null || _currentContactInfo$v2 === void 0 ? void 0 : _currentContactInfo$v2.userID);
          });
        } else if ((_currentContactInfo$v3 = currentContactInfo.value) !== null && _currentContactInfo$v3 !== void 0 && _currentContactInfo$v3.groupID) {
          var _contactListMap$value2;
          targetListItem = (_contactListMap$value2 = contactListMap.value) === null || _contactListMap$value2 === void 0 || (_contactListMap$value2 = _contactListMap$value2.groupList) === null || _contactListMap$value2 === void 0 || (_contactListMap$value2 = _contactListMap$value2.list) === null || _contactListMap$value2 === void 0 ? void 0 : _contactListMap$value2.find(item => {
            var _currentContactInfo$v4;
            return (item === null || item === void 0 ? void 0 : item.groupID) === ((_currentContactInfo$v4 = currentContactInfo.value) === null || _currentContactInfo$v4 === void 0 ? void 0 : _currentContactInfo$v4.groupID);
          });
        }
        if (targetListItem) {
          currentContactInfo.value = targetListItem;
        }
      }
      // 更新数据
      TUIStore.update(StoreName.CUSTOM, 'currentContactInfo', currentContactInfo.value);
    }
    function onDisplayOnlineStatusUpdated(status) {
      displayOnlineStatus.value = status;
    }
    function onUserStatusListUpdated(list) {
      if ((list === null || list === void 0 ? void 0 : list.size) > 0) {
        userOnlineStatusMap.value = Object.fromEntries(list === null || list === void 0 ? void 0 : list.entries());
      }
    }
    function onCustomerServiceCommercialPluginUpdated(isEnabled) {
      if (!isEnabled) {
        return;
      }
      /// 客户购买客服插件后 engine 通过商业化能力位更新将 enabledCustomerServicePlugin 设置为 true
      var contactListExtensionID = TUIConstants.TUIContact.EXTENSION.CONTACT_LIST.EXT_ID;
      var tuiContactExtensionList = TUICore.getExtensionList(contactListExtensionID);
      var customerData = tuiContactExtensionList.find(extension => {
        var {
          name,
          accountList = []
        } = extension.data || {};
        return name === 'customer' && accountList.length > 0;
      });
      if (customerData) {
        var {
          data,
          text
        } = customerData;
        var {
          accountList
        } = data || {};
        TUIUserService.getUserProfile({
          userIDList: accountList
        }).then(res => {
          if (res.data.length > 0) {
            var customerList = {
              title: text,
              list: res.data.map((item, index) => {
                return _objectSpread(_objectSpread({}, item), {}, {
                  renderKey: generateRenderKey('customerList', item, index),
                  infoKeyList: [],
                  btnKeyList: ['enterC2CConversation']
                });
              }),
              key: 'customerList'
            };
            contactListMap.value = _objectSpread(_objectSpread({}, contactListMap.value), {}, {
              customerList
            });
          }
        }).catch(() => {});
      }
    }
    function onGroupListUpdated(groupList) {
      updateContactListMap('groupList', groupList);
    }
    function onUserBlacklistUpdated(userBlacklist) {
      updateContactListMap('blackList', userBlacklist);
    }
    function onFriendApplicationUnreadCountUpdated(friendApplicationUnreadCount) {
      contactListMap.value.friendApplicationList.unreadCount = friendApplicationUnreadCount;
    }
    function onFriendListUpdated(friendList) {
      updateContactListMap('friendList', friendList);
    }
    function onFriendApplicationListUpdated(friendApplicationList) {
      updateContactListMap('friendApplicationList', friendApplicationList);
    }
    function updateContactListMap(key, list) {
      contactListMap.value[key].list = list;
      contactListMap.value[key].list.map((item, index) => item.renderKey = generateRenderKey(key, item, index));
      updateCurrentContactInfoFromList(contactListMap.value[key].list, key);
    }
    function updateCurrentContactInfoFromList(list, type) {
      var _currentContactInfo$v5, _currentContactInfo$v6;
      if (!((_currentContactInfo$v5 = currentContactInfo.value) !== null && _currentContactInfo$v5 !== void 0 && _currentContactInfo$v5.userID) && !((_currentContactInfo$v6 = currentContactInfo.value) !== null && _currentContactInfo$v6 !== void 0 && _currentContactInfo$v6.groupID)) {
        return;
      }
      if (type === currentContactListKey.value || contactSearchingStatus.value) {
        currentContactInfo.value = (list === null || list === void 0 ? void 0 : list.find(item => {
          var _currentContactInfo$v7, _currentContactInfo$v8;
          return (item === null || item === void 0 ? void 0 : item.groupID) && (item === null || item === void 0 ? void 0 : item.groupID) === ((_currentContactInfo$v7 = currentContactInfo.value) === null || _currentContactInfo$v7 === void 0 ? void 0 : _currentContactInfo$v7.groupID) || (item === null || item === void 0 ? void 0 : item.userID) && (item === null || item === void 0 ? void 0 : item.userID) === ((_currentContactInfo$v8 = currentContactInfo.value) === null || _currentContactInfo$v8 === void 0 ? void 0 : _currentContactInfo$v8.userID);
        })) || {};
        TUIStore.update(StoreName.CUSTOM, 'currentContactInfo', currentContactInfo.value);
      }
    }
    function generateRenderKey(contactListMapKey, contactInfo, index) {
      return "".concat(contactListMapKey, "-").concat(contactInfo.userID || contactInfo.groupID || 'index' + index);
    }
    function onCurrentContactSearchResultUpdated(searchResult) {
      contactSearchResult.value = searchResult;
    }
    function onCurrentContactSearchingStatusUpdated(searchingStatus) {
      contactSearchingStatus.value = searchingStatus;
      TUIStore.update(StoreName.CUSTOM, 'currentContactInfo', {});
      TUIStore.update(StoreName.CUSTOM, 'currentContactListKey', '');
    }
    function onCurrentContactInfoUpdated(contactInfo) {
      currentContactInfo.value = contactInfo;
    }
    function onCurrentContactListKeyUpdated(contactListKey) {
      console.log("currentContactListKey.value-->", currentContactListKey.value);
      currentContactListKey.value = contactListKey;
    }
    provide('userOnlineStatusMap', userOnlineStatusMap);
    return (_ctx, _cache) => {
      return !_unref(contactSearchingStatus) ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        class: _normalizeClass(['tui-contact-list', !_unref(isPC) && 'tui-contact-list-h5'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactListMap), (contactListObj, key) => {
        return _openBlock(), _createElementBlock("li", {
          key: key,
          class: "tui-contact-list-item"
        }, [_createElementVNode("header", {
          class: "tui-contact-list-item-header",
          onClick: $event => toggleCurrentContactList(key)
        }, [_createElementVNode("div", _hoisted_2, [_createVNode(Icon, {
          file: _unref(currentContactListKey) === key ? _unref(downSVG) : _unref(rightSVG),
          width: "16px",
          height: "16px"
        }, null, 8, ["file"]), _createElementVNode("div", null, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(contactListObj.title))), 1)]), _createElementVNode("div", _hoisted_3, [contactListObj.unreadCount ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(contactListObj.unreadCount), 1)) : _createCommentVNode("", true)])], 8, _hoisted_1), _createElementVNode("ul", {
          class: _normalizeClass(['tui-contact-list-item-main', _unref(currentContactListKey) === key ? '' : 'hidden'])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactListObj.list, contactListItem => {
          return _openBlock(), _createElementBlock("li", {
            key: contactListItem.renderKey,
            class: _normalizeClass(["tui-contact-list-item-main-item", ['selected']]),
            onClick: $event => selectItem(contactListItem)
          }, [_createVNode(ContactListItem, {
            item: contactListItem,
            displayOnlineStatus: _unref(displayOnlineStatus) && key === 'friendList'
          }, null, 8, ["item", "displayOnlineStatus"])], 8, _hoisted_5);
        }), 128))], 2)]);
      }), 128))], 2)) : (_openBlock(), _createElementBlock("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactSearchResult), (item, key) => {
        return _openBlock(), _createElementBlock("li", {
          key: key,
          class: "tui-contact-list-item"
        }, [item.list[0] ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(item.label))), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (listItem, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["tui-contact-search-list-item", ['selected']]),
            onClick: $event => selectItem(listItem)
          }, [_createVNode(ContactListItem, {
            item: listItem,
            displayOnlineStatus: false
          }, null, 8, ["item"])], 8, _hoisted_9);
        }), 128))])) : _createCommentVNode("", true)]);
      }), 128)), _unref(isContactSearchNoResult) ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(TUITranslateService).t("TUIContact.无搜索结果")), 1)) : _createCommentVNode("", true)]));
    };
  }
});